import { Action } from 'redux-actions';
import { put } from 'redux-saga/effects';
import { batchActions } from 'redux-batched-actions';

import { CheckinOrderFragment, CheckoutOrderFragment } from '@websky/graphql';
import { OrderSegments, OrderTravellers, OrderServices, OrderCapabilities } from './types';

import { setTravellers } from './travellers/actions';
import { createInitialOrderTravellers } from '../lib/createInitialOrderTravellers';

export function* createInitialOrderStateSagas({ payload }: Action<CheckoutOrderFragment | CheckinOrderFragment>) {
	const actions: Action<OrderSegments | OrderTravellers | OrderServices | OrderCapabilities>[] = [
		setTravellers(createInitialOrderTravellers(payload.travellers))
	];

	yield put(batchActions(actions));
}
